const reducer = (state, action) => ({
  ...state,
  loaded: false,
  serverError: action.error,
  waiting: false,
});

export default reducer;
